const COURSE_CONFIG = {
  minDateLimit: new Date('2020-01-01'),
  maxDateLimit: new Date('2100-01-01'),
};

export default COURSE_CONFIG;
